import React, { PureComponent } from "react";

import iWillTellYouAlbumCoverImage from "./i-will-tell-you-album-cover.jpg";

class NortonMusicPage extends PureComponent {
  render() {
    return (
      <div>
        <h1>I Will Tell You</h1>

        <div
          style={{
            margin: 5
          }}
        >
          <p>
            The single I Will Tell You was recorded in Marshall, Minnesota in
            1999.
          </p>

          <p>
            Scott Jyrkas - vocals, drums
            <br />
            Mark Allan - bass, acoustic and electric guitars, harmonica, organ,
            backup vocals
            <br />
            <br />
            Produced, engineered, mixed, and mastered by Mark Allan.
          </p>

          <img
            alt="I Will Tell You - 1999"
            src={iWillTellYouAlbumCoverImage}
            style={{
              width: "256",
              height: "auto",
              maxWidth: "256"
            }}
          />

          <iframe
            title="I Will Tell You - Scott Jyrkas - SoundCloud"
            width="100%"
            height="300"
            scrolling="no"
            frameborder="no"
            allow="autoplay"
            src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/483382236&color=%230066cc&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
          />
        </div>
      </div>
    );
  }
}

export default NortonMusicPage;



// WEBPACK FOOTER //
// ./src/routes/music/i-will-tell-you/IWillTellYouMusicPage.js